import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import {DetailsLayout} from '../Layout';

function DetailsTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    return (
            <FormField
                currrentUser={currentUser}
                layoutId='AC028D08-B2EE-4217-B510-8B132D65212E'
                layoutName='OMTransactionprofileDetailForm'
                defaultFormSchema={DetailsLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.handleDetailsFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DetailsTab);
